import { render, staticRenderFns } from "./directCompetitionArea.vue?vue&type=template&id=5dd116d6&scoped=true"
import script from "./directCompetitionArea.vue?vue&type=script&lang=js"
export * from "./directCompetitionArea.vue?vue&type=script&lang=js"
import style0 from "./directCompetitionArea.vue?vue&type=style&index=0&id=5dd116d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd116d6",
  null
  
)

export default component.exports